import { createSlice } from '@reduxjs/toolkit'

const defaultData = {
  memberId : null,
  couponId : null,
  qrCode : '',
}

export const MemberSlice = createSlice({
  name: 'member',
  initialState: defaultData,
  reducers: {
    setMember: (state, action) => {
      for (const [key, value] of Object.entries(action.payload)) {
        // console.log(`${key}: ${value}`);
        state[key] = value;
      }
    },
    resetMember: () => defaultData
  },
})

// Action creators are generated for each case reducer function
export const {
  setMember,
  resetMember
} = MemberSlice.actions

export default MemberSlice.reducer